import React from 'react';
import { createUseStyles } from 'react-jss';
import KeyValue from './KeyValue';
import { Button } from 'primereact/button';
import useMobileHandler from '../hooks/useMobileHandler';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

function SearchResultGas({ result,leadId, onCompanySelected }) {

    const mobileHandler = useMobileHandler();

    const st = styles();

    console.log(JSON.stringify(result,null, 2));


    if (mobileHandler.isMobile)
        return (
            <div className='flex flex-column resultItemContainer mb-3 l	'>
                <div className=' mz_center '>{result.nome}</div>
                <div className='resultItemInnerContainer pb-3'>

                    <div className='flex flex-row justify-content-between p-2	'>
                        <div className=''>
                            <img className='logo_azienda_mobile' src={result.url_immagine} ></img>

                        </div>
                        <div >
                            <div className='textBold font14'>Prezzo/Mese</div>
                            <div className='textPromo' >{result.spesa_mensile_gas} €</div>
                        </div>
                    </div>
                    <div>
                        <div className='mt-1 pl-4 '>
                            <KeyValue key1={"Tipologia Contratto:"} value={result.tipo_contratto} />
                            <KeyValue key1={"Offerta:"} value={result.nome} />
                            <KeyValue key1={"Tipologia Tariffa:"} value={result.tipo_tariffa } />
                            <KeyValue key1={"Prezzo smc:"} value={result.prezzo_smc} />
                            <KeyValue key1={"Quota Fissa:"} value={result.quota_fissa_inclusa } />
                            <KeyValue key1={"Bonus:"} value={result.bonus  } />
                            <KeyValue key1={"Periodicità Bolletta:"} value={result.periodicita_fatturazione  } />
                            <KeyValue key1={"Pagamenti Accettati:"} value={result.pagamenti_accettati } />
                        </div>
                    </div>
                    <div className=' flex justify-content-center mt-3'>
                        <Button className='mz_fit_content paddingUnset shadow-4' style={{ width: "max-content" }} onClick={()=> onCompanySelected(leadId, result.id) }    >
                            <div className='flex flex-row ml-2 mr-2'  >
                                <img alt="logo" src={IMAGE_URL + "/robot-lia.png"} className="parla_ia  align-self-center"></img>
                                <div className='pl-2 mz_fit_content align-self-center'>Parla con Lia</div>
                                {/*<div className='mz_fit_content textSmall'>con un esperto</div>*/}
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        )


    return (
        <div className={"mb-2"}>

            <div className='resultItemContainer'>
                <div className='mz_fit_content mz_center '>{result.nome}</div>
                <div className='resultItemInnerContainer'>
                    <div className='grid'>
                        <div className='col-2'>
                            <img className='logo_azienda' src={result.url_immagine} ></img>
                        </div>
                        <div className='col-5 mt-1'>
                            <KeyValue key1={"Tipologia Contratto:"} value={result.tipo_contratto} />
                            <KeyValue key1={"Offerta:"} value={result.nome} />
                            <KeyValue key1={"Tipologia Tariffa:"} value={result.tipo_tariffa } />
                            <KeyValue key1={"Prezzo smc:"} value={result.prezzo_smc} />
                            <KeyValue key1={"Quota Fissa:"} value={result.quota_fissa_inclusa } />
                            <KeyValue key1={"Bonus:"} value={result.bonus  } />
                            <KeyValue key1={"Periodicità Bolletta:"} value={result.periodicita_fatturazione  } />
                            <KeyValue key1={"Pagamenti Accettati:"} value={result.pagamenti_accettati } />
                         
                        </div>


                        <div className='col-2 flex flex-column'>
                            <div className='textBold font14'>Prezzo/Mese</div>
                            <div className='textPromo' >{result.spesa_mensile_gas} €</div>
                        </div>

                        <div className='col-3 flex justify-content-center mt-3'>
                            <Button className='mz_fit_content paddingUnset shadow-4' style={{ width: "max-content" }} onClick={()=> onCompanySelected(leadId, result.id) }     >
                                <div className='flex flex-column ml-2 mr-2'  >
                                    <img alt="logo" src={IMAGE_URL + "/logoAI.png"} className="parla_ia  align-self-center"></img>
                                    <div className='mz_fit_content'>Parla con l'IA</div>
                                    {/*<div className='mz_fit_content textSmall'>con un esperto</div>*/}
                                </div>
                            </Button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
}

const styles = createUseStyles({
    container: {

    }
});

export default SearchResultGas;